var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h2', [_vm._v("我报名的活动")]), _c('a-divider'), _c('div', {
    staticClass: "pannel"
  }, [_c('a-button', {
    attrs: {
      "type": "danger",
      "icon": "right-circle"
    },
    on: {
      "click": function click($event) {
        return _vm.toOrder();
      }
    }
  }, [_vm._v("查看我的订单")]), _c('a-list', {
    attrs: {
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination,
      "locale": {
        emptyText: '暂无报名的活动'
      }
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          staticClass: "item-card"
        }, [_c('a-row', {
          attrs: {
            "gutter": 24
          }
        }, [_c('a-col', {
          attrs: {
            "sm": 8,
            "xs": 24
          }
        }, [_c('div', {
          staticClass: "img-zoom",
          on: {
            "click": function click($event) {
              return _vm.toEventDetail(item);
            }
          }
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.eventCover_url,
            "alt": ""
          }
        })])]), _c('a-col', {
          attrs: {
            "sm": 12,
            "xs": 24
          }
        }, [_c('h2', [_vm._v(_vm._s(item.eventName) + " \n              "), _c('a-tag', [_vm._v(_vm._s(item.eventType_dictText))]), item.applyStatus == 0 ? _c('a-tag', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("未支付")]) : _vm._e(), item.applyStatus == -1 ? _c('a-tag', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("已退费")]) : _vm._e()], 1), _c('p', [_vm._v("赛项：" + _vm._s(_vm.getDictValue(item.myEventCategoryPid)) + " 组别：" + _vm._s(_vm.getDictValue(item.myEventCategory)))]), _c('p', [_vm._v("报名开始时间：" + _vm._s(item.eventBegin))]), _c('p', [_vm._v("报名截止时间：" + _vm._s(item.eventEnd))])]), item.applyStatus >= 0 ? _c('a-col', {
          staticClass: "event-opts",
          attrs: {
            "sm": 4,
            "xs": 24
          }
        }, [_c('a-button', {
          on: {
            "click": function click($event) {
              return _vm.showApplyEvent(item);
            }
          }
        }, [_vm._v("报名信息")]), item.ticketId ? _c('a-button', {
          attrs: {
            "type": "dashed"
          },
          on: {
            "click": function click($event) {
              return _vm.download(item.ticketUrl);
            }
          }
        }, [_vm._v("准考证")]) : _vm._e(), item.applyStatus == 1 && item.takePartType == 1 ? _c('a-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.showSubmitWork(item);
            }
          }
        }, [_vm._v(_vm._s(item.worksVOS.length > 0 ? '查看作品' : '作品提交'))]) : _vm._e(), item.applyStatus == 1 && item.takePartType == 0 && item.examStatus > 0 ? _c('a-button', {
          attrs: {
            "type": item.examStatus == 2 ? 'danger' : 'primary'
          },
          on: {
            "click": function click($event) {
              return _vm.toPaper(item);
            }
          }
        }, [_vm._v(_vm._s(item.examStatus == 2 ? '去测评' : '测评模拟'))]) : _vm._e(), item.certId && item.certId != '-1' ? _c('a-button', {
          on: {
            "click": function click($event) {
              return _vm.toCert(item.certId);
            }
          }
        }, [_vm._v("测评证书")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1);
      }
    }])
  })], 1), _c('EventApplyModal', {
    ref: "applyModal"
  }), _c('SubmitWorkModal', {
    ref: "submitModal",
    on: {
      "ok": _vm.submitOk
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };